import { useMemo } from 'react';
import { useGetUserSubscriptionInfoQuery } from 'src/store/services';
import { useGetUser, useTeamInfo } from 'src/hooks';
import { isAppleOrAmpSource } from 'src/utils';
import { LEGACY_PLAN_KINDS } from 'src/constants';
import { PlanKind } from 'src/types';

export const useSubscriptionInfo = () => {
  const {
    isOpenTier,
    isFreeTier,
    isTeamsTier,
    isEnterpriseTrialTier,
    isEnterpriseTier,
    user_id,
  } = useGetUser();
  const { isOwner } = useTeamInfo();

  const {
    data: subscriptionInfo,
    isLoading: isSubscriptionInfoLoading,
    isFetching: isSubscriptionInfoFetching,
  } = useGetUserSubscriptionInfoQuery(
    {
      user_id: user_id,
    },
    {
      skip:
        isOpenTier ||
        isFreeTier ||
        isEnterpriseTier ||
        isEnterpriseTrialTier ||
        (isTeamsTier && !isOwner),
    },
  );

  const isLegacyPlan = useMemo(
    () => LEGACY_PLAN_KINDS.includes(subscriptionInfo?.plan_kind as PlanKind),
    [subscriptionInfo],
  );

  return useMemo(
    () => ({
      subscriptionInfo,
      isSubscriptionInfoLoading,
      isSubscriptionInfoFetching,
      isAppleOrAmpPayment: isAppleOrAmpSource(subscriptionInfo?.source),
      isAmpPayment: subscriptionInfo?.source === 'amp',
      isLegacyPlan,
    }),
    [
      subscriptionInfo,
      isSubscriptionInfoLoading,
      isSubscriptionInfoFetching,
      isLegacyPlan,
    ],
  );
};
